"use client";

import { useEffect } from "react";
import { useParams } from "next/navigation";
import { reportError } from "@/lib/bug-reporter";

const copy = {
  fr: { title: "Une erreur inattendue s'est produite", reload: "Recharger la page" },
  en: { title: "An unexpected error occurred", reload: "Reload the page" },
};

export default function ErrorBoundary({ error }: { error: Error & { digest?: string } }) {
  const { lang } = useParams<{ lang: string }>();
  const t = lang === "en" ? copy.en : copy.fr;

  useEffect(() => {
    reportError(error, { boundary: "error" });
  }, [error]);

  return (
    <section
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: "32px",
        padding: "clamp(64px, 8vw, 128px) clamp(20px, 5.5vw, 80px)",
        boxSizing: "border-box",
        textAlign: "center",
      }}
    >
      <h1
        style={{
          margin: "0",
          fontSize: "clamp(30px, 3.8vw, 60px)",
          lineHeight: "1.06",
          letterSpacing: "-0.025em",
          fontWeight: 800,
          fontStretch: "118%",
          maxWidth: "18ch",
        }}
      >
        {t.title}
      </h1>
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="btn"
        style={{
          display: "inline-flex",
          alignItems: "center",
          minHeight: "52px",
          padding: "0 28px",
          border: "0",
          cursor: "pointer",
          fontFamily: "inherit",
          background: "#0B0D10",
          color: "#FFFFFF",
          fontSize: "16px",
          fontWeight: 700,
        }}
      >
        {t.reload}
      </button>
    </section>
  );
}
